import { Col } from 'components';
import ReactPlayer from 'react-player';

const Youtube = ({ youtubeId }) => {
  return (
    <Col noFlex ht="100%" wid="500px" center>
      <ReactPlayer url={`https://www.youtube.com/watch?v=${youtubeId}`} style={{ maxWidth: 500 }} />
    </Col>
  );
};

export default Youtube;
